import React from 'react'

export const ProfileEditIcon = (props) => (
    <svg style={props.style} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V8" stroke="#151D21" strokeWidth="2"/>
        <path d="M13.1924 1.41421L14.6066 2.82843L8.45673 8.97829L6.68896 9.33185L7.04252 7.56408L13.1924 1.41421Z" stroke="#151D21" strokeWidth="2"/>
    </svg>
)

